import { ROLES } from '@/config'

/**
 * Voci della sidebar. Ogni voce che ha `roles` viene nascosta a chi non li ha
 * (il filtro sta in AppMenu.vue) — la protezione vera resta `meta.roles` sulla rotta.
 *
 * Forma di una voce:
 *   { label, icon: 'pi pi-fw pi-<nome>', to, roles?: [], items?: [] }
 * Icone disponibili: https://primevue.org/icons
 */
export const rawMenuModel = [
  {
    label: 'Principale',
    items: [
      { label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/', roles: [ROLES.ADMIN] },
      { label: 'Abbonamenti', icon: 'pi pi-fw pi-id-card', to: '/subscriptions', roles: [ROLES.ADMIN] },
    ],
  },
  {
    label: 'Anagrafiche',
    items: [
      { label: 'Utenti', icon: 'pi pi-fw pi-users', to: '/users', roles: [ROLES.ADMIN] },
      { label: 'Siti', icon: 'pi pi-fw pi-globe', to: '/sites', roles: [ROLES.ADMIN] },
      { label: 'Piani', icon: 'pi pi-fw pi-tags', to: '/plans', roles: [ROLES.ADMIN] },
    ],
  },
]
